import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {BaseComponent} from '../../../base.component';
import {MasterService} from '../../../../services/master/master.service';
import {ClientService} from '../../../../services/clients/client.service';
import {AlertService} from '../../../../_services/alert.service';


@Component({
  selector: 'app-noteslist',
  templateUrl: './noteslist.component.html',
  styleUrls: ['noteslist.component.css']
})
export class NoteslistComponent extends BaseComponent implements OnInit, OnDestroy {

  shwSearch: boolean = false;
  cp = 1;
  ord = true;
  text;
  getCompanyobj: any = [];
  currentUser;
  companyID: any = '';
  isSuperAdmin = false;
  companyNoteConf: any = [];
  selectedCompany: any = null;
  companyName = "";
  selectedCompanyName;
  private companySub: Subscription;

  constructor(private master: MasterService, private clientService: ClientService,
              private alertService: AlertService) {
    super();
  }
  ngOnInit() {
    this.companyNoteConf = [];
    this.currentUser = JSON.parse(sessionStorage.getItem('userData'));
    this.isSuperAdmin = String(this.currentUser.admin_customer_id) === '0';
    if (!this.isSuperAdmin) {
      this.getCompanyNotes(this.currentUser.admin_customer_id);
    }
    this.getCompany();
  }

  ngOnDestroy(): void {
    if (this.companySub) {
      this.companySub.unsubscribe();
    }
  }

  order: string = 'get_master_theme.theme_name';
  reverse: boolean = false;
  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }
    this.order = value;
  }

  //  ###############  Get Notes Configuration for Company    ###############  //

  onCompanyChange(value?: any) {
    this.getCompanyNotes(value);
  }

  applyHeaderCompany() {
    const working = this.bindWorkingCompany(this.getCompanyobj);
    if (working) {
      if (String(this.companyID) !== String(working)) {
        this.getCompanyNotes(working);
      }
      return;
    }
    if (this.companyID) {
      this.companyID = '';
      this.selectedCompany = null;
    }
  }

  getCompanyNotes(data){
    let compamyId = data;
    
    if(!compamyId){
      this.companyID = '';
      this.selectedCompany = null;
      return;
    }
    this.companyID = String(compamyId);

    this.ngxSpinnerService.show();
    this.master.getCompanyNotesDetails(compamyId).subscribe((data: any) => {
      if (data.status) {
        this.selectedCompany = data.data[0];
      } else {
        this.selectedCompany = null;
      }
      this.ngxSpinnerService.hide();
    });
  }

  //  ###############  Get Companies List ####################  //

  getCompany() {
    this.clientService.getBUCompanies().subscribe(data => {
      this.getCompanyobj = data.data || [];
      if (this.isSuperAdmin) {
        this.applyHeaderCompany();
        if (!this.companySub) {
          this.companySub = this.workingCompanyService.companyChange$.subscribe(() => {
            this.applyHeaderCompany();
          });
        }
      }
    }, error => {
    });
  }

  //   ############## Update Notes Status   ################  //
  updateNoteStatus(event){
    event.preventDefault();
    const obj = {
      lengthNum: this.selectedCompany.note_length,
      company: this.selectedCompany.company_id,
      isactive: !this.selectedCompany.isactive
    };

    this.confirmationDialogService.confirm('PLEASE CONFIRM', 'Are you sure you want to change the Notes Status?', 'YES', 'NO')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.master.updateCompanyNoteDetails(obj).subscribe(data => {
            if (data.status) {
              this.master.getCompanyNotesDetails(this.selectedCompany.company_id).subscribe((data2: any) => {
                this.selectedCompany = null;
                if (data.status) {
                  this.selectedCompany = data2.data[0];
                } else {
                  this.selectedCompany = null;
                }
                this.ngxSpinnerService.hide();
              });
              setTimeout(() => {
                this.toastrService.success('Notes Updated Successfully');
              }, 1000);
            } else {
              this.toastrService.error(data.message);
            }
            this.ngxSpinnerService.hide();
          }, error => {
           // console.log(error);
            this.ngxSpinnerService.hide();
          });
        }
      })
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));

  }

}
